module.exports = __webpack_public_path__ + "1c2f01a8f5fe00b67970c1b3ec08d927.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/image/ic_messages.svg
// module id = 282
// module chunks = 0